import { Button, Layout } from 'antd';
import { PageNotFound } from 'components/Atoms';
import { Header, SideBar } from 'components/Organisms';
import React, { useState } from 'react';
import {
  Redirect,
  Route,
  Switch,
  useHistory,
  useLocation,
} from 'react-router-dom';
import renderRoutes from 'routers/render';
import * as routePath from 'routers/route-path';
import cn from 'classnames';
import './styles.scss';
import useProfile from 'hooks/useProfile';
import useBreadcrumb from 'hooks/useBreadcrumb';

const { Content } = Layout;

const PrivateLayout = () => {
  const [collapsed, setColollapsed] = useState(false);
  let history = useHistory();
  let location = useLocation();

  const { data: userInfo } = useProfile();
  const { breadcrumbs } = useBreadcrumb();

  const _onCollapse = () => {
    setColollapsed(!collapsed);
  };

  return (
    <Layout className="site-layout">
      <SideBar collapsed={collapsed} />
      <Layout className="page-layout">
        <Header
          className="site-layout-background"
          style={{ padding: 0 }}
          collapsed={collapsed}
          onCollapse={_onCollapse}
        />
        {breadcrumbs}
        <Content
          className={cn('page-content', {
            'light-gray': location?.pathname.includes(routePath.VIEW_REPORT),
          })}
        >
          <div className="content">
            <Switch>
              {renderRoutes(true, userInfo?.role)}
              <Route exact path="/">
                <Redirect to={routePath.USER} />
              </Route>
              <Route path="*">
                <PageNotFound
                  extra={
                    <div className="text-center">
                      <p>Whoops! Page not found.</p>
                      <Button
                        className="btn-primary-custom"
                        onClick={() => history.replace('/')}
                      >
                        Back Home
                      </Button>
                    </div>
                  }
                />
              </Route>
            </Switch>
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

PrivateLayout.propTypes = {};

export default PrivateLayout;
